export default __webpack_public_path__ + "static/media/slide8.e2a046f7.jpg";